import React, { useEffect } from 'react'
import Header from './masterLayout/Header'
import Footer from './masterLayout/Footer'
import Navigation from './masterLayout/Navigation'
import LoadTemplate from './masterLayout/LoadTemplate'
import ReactGA from 'react-ga4'
import './assets/css/style.css'
import './assets/sass/style.scss'
import 'font-awesome/css/font-awesome.min.css'
import { withRouter } from 'react-router-dom'

function App() {
 useEffect(() => {
  ReactGA.initialize('G-2HEE518996')
 }, [])

 return (
  <React.Fragment>
   <div className="wrapper">
    <Header />
    <Navigation />
    <div className="templateBody" id="templateBody">
     <LoadTemplate />
    </div>
    <Footer />
   </div>
  </React.Fragment>
 )
}

export default withRouter(App)
